import React, {FunctionComponent, PropsWithChildren} from 'react';
import TextField from '@mui/material/TextField';
import {DatePicker} from '@mui/x-date-pickers';
import {TreatmentListJson} from '../../../api/generated/medical-rest';
import {Checkbox, FormControlLabel} from "@mui/material";
import {HealthAndSafety, HealthAndSafetyOutlined} from "@mui/icons-material";
import FormActions from '../../Common/form-actions';

export type TreatmentFormProps = PropsWithChildren<TreatmentFormBaseProps & {
    onTimestampChange: (newDate: any) => void;
    onNoteChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onPrivateChange: (isPrivate: boolean) => void;
    treatment: TreatmentListJson;
    hasError?: boolean;
    isPending?: boolean;
}>;

export type TreatmentFormBaseProps = {
    onFormSave: (treatment: TreatmentListJson) => void;
    onFormCancel: () => void;
};

const TreatmentForm: FunctionComponent<TreatmentFormProps> = (props) => {
    const {treatment, hasError, isPending} = props;

    return (
        <>
            {props.children}
            <DatePicker
                label="Durchgeführt am"
                value={treatment.timestamp}
                onChange={props.onTimestampChange}
                slotProps={{ textField: { variant: 'standard' } }}
            />
            <TextField
                id="note-textarea"
                label="Notiz"
                placeholder="Notiz"
                value={treatment.note}
                onChange={props.onNoteChange}
                multiline
            />
            <FormControlLabel
                label={treatment.isPrivate ? 'Von Export exkludiert' : 'Im Export sichtbar'}
                control={
                    <Checkbox
                        icon={<HealthAndSafetyOutlined/>}
                        checkedIcon={<HealthAndSafety/>}
                        checked={treatment.isPrivate}
                        onChange={(ev) => props.onPrivateChange(ev.target.checked)}/>
                }/>

            <FormActions
                onCancel={props.onFormCancel}
                onSave={() => props.onFormSave(treatment)}
                saveDisabled={hasError || isPending}
            />
        </>
    );
};

export default TreatmentForm;
